import React, { useState, useEffect, useContext, useRef } from 'react'
import PriceManager, { PriceManagerRef } from '../../../PriceManager'
import QuantityManager, { QuantityManagerRef } from '../../../QuantityManager'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  ProgressBarDiv,
  ProgressBarCircle,
  ProgressBarLine,
  InputDiv,
  InputLabel,
  Input,
  ButtonsDiv,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
  WarningDiv,
  WarningText,
} from './style'
import ModalContext from '../../../../contexts/ModalContext'
import StockContext from '../../../../contexts/StockContext'
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowRight from '../../../../assets/addStockModal/pages/arrow-right.svg'
import arrowLeft from '../../../../assets/addStockModal/pages/arrow-left.svg'

const SecondCustomAddPage: React.FC = () => {
  const { stock, setStock } = useContext(StockContext)
  const { setModalActive, setModalSection, itIsUpdate, stockMode, isVariation } =
    useContext(ModalContext)

  const priceManagerRef = useRef<PriceManagerRef>(null)
  const quantityManagerRef = useRef<QuantityManagerRef>(null)
  const [warningMessage, setWarningMessage] = useState('')

  const isFashion = stockMode === 'fashion'

  const getHeaderTitle = () => {
    if (isVariation) return isFashion ? 'Criar Variação de Tecido' : 'Criar Variação de Estoque'
    if (isFashion) return itIsUpdate ? 'Editar Tecido' : 'Adicionar Tecido'
    return itIsUpdate ? 'Editar Estoque' : 'Adicionar Estoque'
  }
  const headerTitle = getHeaderTitle()

  useEffect(() => {
    setWarningMessage('')
  }, [stock])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    const cleanValue = value.replace(/[^0-9,.]/g, '')
    setStock({ ...stock, [name]: cleanValue })
  }

  const previousPage = () => {
    setModalSection('firstCustomAdd')
  }

  const nextPage = () => {
    if (priceManagerRef.current) {
      priceManagerRef.current.addPendingPrice()
    }
    if (quantityManagerRef.current) {
      quantityManagerRef.current.addPendingQuantity()
      quantityManagerRef.current.savePendingEdit()
    }
    setModalSection('thirdCustomAdd')
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>{headerTitle}</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>

      <ProgressBarDiv>
        <ProgressBarCircle className='active' />
        <ProgressBarLine className='active' />
        <ProgressBarCircle className='active' />
        <ProgressBarLine />
        <ProgressBarCircle />
      </ProgressBarDiv>

      <div style={{ display: 'flex', gap: '2.5vw', width: '57vw', marginLeft: '1.5vw', marginTop: '2vh', minHeight: '38vh' }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '2vh' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1vw' }}>
            <InputDiv style={{ position: 'relative' }}>
              <InputLabel htmlFor='dimension1'>Dimensão 1</InputLabel>
              <Input
                placeholder='Digite aqui'
                name='dimension1'
                value={stock.dimension1 || ''}
                onChange={handleChange}
                autoComplete='off'
                style={{ width: '100%' }}
              />
            </InputDiv>

            <InputDiv style={{ position: 'relative' }}>
              <InputLabel htmlFor='dimension2'>Dimensão 2</InputLabel>
              <Input
                placeholder='Digite aqui'
                name='dimension2'
                value={stock.dimension2 || ''}
                onChange={handleChange}
                autoComplete='off'
                style={{ width: '100%' }}
              />
            </InputDiv>
          </div>

          <InputDiv style={{ position: 'relative' }}>
            <InputLabel htmlFor='totalCmc'>CMC Total</InputLabel>
            <Input
              placeholder='Digite aqui'
              name='totalCmc'
              value={stock.totalCmc || ''}
              onChange={handleChange}
              autoComplete='off'
              style={{ width: '100%' }}
            />
          </InputDiv>

          <QuantityManager
            ref={quantityManagerRef}
            quantities={stock.quantities || []}
            onChange={(quantities) => setStock((prev: any) => ({ ...prev, quantities }))}
            baseUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/resources` || ''}
            label="Quantidades"
            materialSpecs={{
              format: stock.format,
              density: stock.density,
              dimension1: stock.dimension1,
              dimension2: stock.dimension2
            }}
            setWarningMessage={setWarningMessage}
            isFashion={isFashion}
          />
        </div>

        <div style={{ flex: 1, borderLeft: '1px solid #eee', paddingLeft: '2.5vw' }}>
          <PriceManager
            ref={priceManagerRef}
            prices={stock.prices || []}
            onChange={(prices) => setStock((prev: any) => ({ ...prev, prices }))}
            baseUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/resources` || ''}
            label="Preços"
            allowedUnits={['kg', 'mm', 'un', 'm²', 'm linear', 'm2', 'm', 'linear', 'metro quadrado', 'metro linear']}
          />
        </div>
      </div>

      <ButtonsDiv>
        <WarningDiv>
          <WarningText>{warningMessage}</WarningText>
        </WarningDiv>

        <PreviousButtonDiv onClick={previousPage}>
          <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
          <PreviousButtonText>Voltar</PreviousButtonText>
        </PreviousButtonDiv>

        <NextButtonDiv onClick={nextPage}>
          <NextButtonImage src={arrowRight} alt='Right arrow icon' />
          <NextButtonText>Próximo</NextButtonText>
        </NextButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default SecondCustomAddPage
